import { handleActions } from "redux-actions";

export default handleActions(
  {
    SPACE_MODAL: {
      CLOSE: () => ({ isSpaceModalOpen: false }),
      OPEN: () => ({ isSpaceModalOpen: true }),
    },
  },
  {},
  { namespace: "_" }
);
